import React from 'react';

export interface NativeControlProps extends React.HTMLProps<HTMLInputElement> {
  checked: boolean;
  disabled: boolean;
  id?: string;
  rippleActivatorRef: React.RefObject<HTMLInputElement>;
  onChange: (evt: React.ChangeEvent<HTMLInputElement>) => void;
}

export class NativeControl extends React.Component<NativeControlProps, {}> {
  static defaultProps: Partial<NativeControlProps> = {
    checked: false,
    disabled: false,
    onChange: () => {},
  };

  render() {
    const {rippleActivatorRef, ...otherProps} = this.props;
    return (
      <input
        type='checkbox'
        className='mdc-checkbox__native-control'
        ref={rippleActivatorRef}
        {...otherProps}
      />
    );
  }
}

export default NativeControl;
